import * as angular from "angular";
import * as _ from "lodash";
import {IFilterService} from "angular";
import {AgentStatusType} from "../types/agentStatus.type";
import {AgentModel} from "../angular/models/agent.model";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class AgentsAlerts {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService, private $filter: IFilterService) {
  }

  // GET MANY //
  getManyError() {
    let message = {
      body: 'AGENT_GET_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE //
  createSuccess() {
    let message = {
      body: 'AGENT_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError(error) {
    let message = {
      body: 'AGENT_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  // ADD //
  addSuccess() {
    let message = {
      body: 'AGENT_ADD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addError() {
    let message = {
      body: 'AGENT_ADD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    let message = {
      body: 'AGENT_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError(error) {

    let body;
    switch (error && error.code) {
      case 413102:
        body = 'AGENT_UPDATE_ERROR_413102';
        break;
      case 400416:
        body = 'AGENT_UPDATE_ERROR_413102';
        break;
      case 400417:
        body = 'AGENT_UPDATE_ATTACHED_TO_RESOURCE_ERROR';
        break;
      case 413103:
        body = 'AGENT_UPDATE_ERROR_413103';
        break;
      case 412205:
        body = 'AGENT_UPDATE_ERROR_412205';
        break;
      default:
        body = 'AGENT_UPDATE_ERROR';
        break;
    }

    let replaceObject;
    switch (error && error.code) {
      case 400417:
        replaceObject = {resourceName: error?.more_info}
        break;
      default:
        replaceObject = {};
        break;
    }


    let message = {
      body: body,
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message, replaceObject)
  }

  // UPDATE STATUS //
  updateStatusSuccess(status: AgentStatusType) {
    let message = {
      body: 'AGENT_UPDATE_STATUS_SUCCESS'
    };
    if (status) {
      status = this.$filter<any>('translate')(status);
    }
    return this.bringozToastService.success(message, {status: status})
  }

  updateStatusInfo() {
    let message = {
      body: 'AGENT_UPDATE_STATUS_INFO'
    };
    return this.bringozToastService.info(message)
  }

  updateStatusError(error?) {
    let message = {
      body: 'AGENT_UPDATE_STATUS_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE //
  removeSuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_REMOVE_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  removeError() {
    let message = {
      body: 'AGENT_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  deleteOneSuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_DELETE_ONE_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  deleteOneError() {
    let message = {
      body: 'AGENT_DELETE_ONE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REFRESH ITINERARY //
  updateItinerarySuccess() {
    let message = {
      body: 'AGENT_REFRESH_ITINERARY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateItineraryError() {
    let message = {
      body: 'AGENT_REFRESH_ITINERARY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  itineraryChangeInfo() {
    let message = {
      body: 'AGENT_ITINERARY_CHANGE_INFO',
      details: 'AGENT_ITINERARY_CHANGE_INFO_DETAILS'
    };
    return this.bringozToastService.info(message)
  }

  // ADD TO TEAM //
  addToTeamSuccess() {
    let message = {
      body: 'AGENT_ADD_TO_TEAM_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addToTeamError() {
    let message = {
      body: 'AGENT_ADD_TO_TEAM_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE FROM TEAM //
  removeFromTeamSuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_REMOVE_FROM_TEAM_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  removeFromTeamError() {
    let message = {
      body: 'AGENT_REMOVE_FROM_TEAM_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD TO BRANCH //
  addToBranchSuccess() {
    let message = {
      body: 'AGENT_ADD_TO_BRANCH_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addToBranchError() {
    let message = {
      body: 'AGENT_ADD_TO_BRANCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE FROM BRANCH //
  removeFromBranchSuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_REMOVE_FROM_BRANCH_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  removeFromBranchError() {
    let message = {
      body: 'AGENT_REMOVE_FROM_BRANCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD TO DEPOT //
  addToDepotSuccess() {
    let message = {
      body: 'AGENT_ADD_TO_DEPOT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addToDepotError() {
    let message = {
      body: 'AGENT_ADD_TO_DEPOT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE FROM DEPOT //
  removeFromDepotSuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_REMOVE_FROM_DEPOT_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  removeFromDepotError() {
    let message = {
      body: 'AGENT_REMOVE_FROM_DEPOT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SWAP DELIVERY //
  swapDeliverySuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_SWAP_DELIVERY_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  swapDeliveryError() {
    let message = {
      body: 'AGENT_SWAP_DELIVERY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SWAP DELIVERIES //
  swapDeliveriesSuccess(agent: AgentModel) {
    let message = {
      body: 'X_AGENT_SWAP_DELIVERIES_SUCCESS'
    };
    let name = this._getAgentName(agent);
    return this.bringozToastService.success(message, {name: name})
  }

  swapDeliveriesError() {
    let message = {
      body: 'AGENT_SWAP_DELIVERIES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE REQUIREMENT //
  updateRequirementSuccess() {
    let message = {
      body: 'AGENT_UPDATE_REQUIREMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateRequirementError() {
    let message = {
      body: 'AGENT_UPDATE_REQUIREMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE PASSWORD //
  updatePasswordSuccess(shipper?) {
    let message = {
      body: 'AGENT_UPDATE PASSWORD_SUCCESS'
    };
    let name;
    if (shipper) {
      name = shipper.firstName + " " + shipper.lastName;
    }
    return this.bringozToastService.success(message, {name: name})
  }

  updatePasswordError() {
    let message = {
      body: 'AGENT_UPDATE PASSWORD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // SELECT_SCHEDULE_TEMPLATE //
  selectScheduleTemplateSuccess() {
    let message = {
      body: 'SCHEDULE_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  selectScheduleTemplateError() {
    let message = {
      body: 'SCHEDULE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CLEAR_SCHEDULE //
  clearScheduleSuccess() {
    let message = {
      body: 'AGENT_CLEAR_SCHEDULE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  clearScheduleError() {
    let message = {
      body: 'AGENT_CLEAR_SCHEDULE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // BULK_PREFERENCES_UPDATE //
  bulkPreferencesUpdateInfo() {
    let message = {
      body: 'AGENT_BULK_PREFERENCES_UPDATE_INFO'
    };
    return this.bringozToastService.info(message)
  }

  bulkPreferencesUpdateSuccess() {
    let message = {
      body: 'AGENT_BULK_PREFERENCES_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message, {name: name})
  }

  bulkPreferencesUpdateError() {
    let message = {
      body: 'AGENT_BULK_PREFERENCES_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_ASSISTANTS //
  updateAssistantsSuccess() {
    let message = {
      body: 'AGENT_UPDATE_ASSISTANTS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateAssistantsError() {
    let message = {
      body: 'AGENT_UPDATE_ASSISTANTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getAssistantsError() {
    let message = {
      body: 'AGENT_GET_ASSISTANTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createManyError(error) {
    const message = {
      body: 'AGENT_CREATE_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

  // UPLOAD //
  uploadError() {
    const message = {
      body: 'AGENT_UPLOAD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'AGENT_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'AGENT_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //////////////////////////////////////// DOCUMENTS ////////////////////////////////////////

  getDocumentsError() {
    const message = {
      body: 'AGENT_GET_DOCUMENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createDocumentSuccess() {
    const message = {
      body: 'AGENT_CREATE_DOCUMENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createDocumentError() {
    const message = {
      body: 'AGENT_CREATE_DOCUMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateDocumentSuccess() {
    const message = {
      body: 'AGENT_UPDATE_DOCUMENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateDocumentError() {
    const message = {
      body: 'AGENT_UPDATE_DOCUMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteDocumentSuccess() {
    const message = {
      body: 'AGENT_DELETE_DOCUMENT_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteDocumentError() {
    const message = {
      body: 'AGENT_DELETE_DOCUMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //////////////////////////////////////// REMINDERS ////////////////////////////////////////

  getRemindersError() {
    const message = {
      body: 'AGENT_GET_REMINDERS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createReminderSuccess() {
    const message = {
      body: 'AGENT_CREATE_REMINDER_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  createReminderError() {
    const message = {
      body: 'AGENT_CREATE_REMINDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  updateReminderSuccess() {
    const message = {
      body: 'AGENT_UPDATE_REMINDER_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  updateReminderError() {
    const message = {
      body: 'AGENT_UPDATE_REMINDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  changeArchiveStatusSuccess() {
    const message = {
      body: 'AGENT_UPDATE_ARCHIVE_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  changeArchiveStatusError() {
    const message = {
      body: 'AGENT_UPDATE_ARCHIVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteReminderSuccess() {
    const message = {
      body: 'AGENT_DELETE_REMINDER_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteReminderError() {
    const message = {
      body: 'AGENT_DELETE_REMINDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  agentGpsNotificationSuccess() {
    const message = {
      body: 'AGENT_GPS_NOTIFICATION_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  agentGpsNotificationError() {
    const message = {
      body: 'AGENT_GPS_NOTIFICATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  agentClockInNotificationSuccess() {
    const message = {
      body: 'AGENT_CLOCK_IN_NOTIFICATION_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  agentClockInNotificationError() {
    const message = {
      body: 'AGENT_CLOCK_IN_NOTIFICATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  saveFavouriteSuccess() {
    const message = {
      body: 'AGENT_SAVE_FAVOURITE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  saveFavouriteError(value) {
    const message = {
      body: 'AGENT_SAVE_FAVOURITE_MAX_ERROR'
    };
    return this.bringozToastService.info(message, {value: value})
  }

  passwordlessSuccess(authType) {
    const message = {
      body: 'AGENT_PASSWORD_LESS_SUCCESS'
    };
    return this.bringozToastService.success(message, {authType: authType})
  }

  passwordlessError(authType) {
    const message = {
      body: 'AGENT_PASSWORD_LESS_ERROR'
    };
    return this.bringozToastService.error(message, {authType: authType})
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getAgentName(agent: AgentModel) {
    let name: string;
    if (agent) {
      name = _.get(agent, 'user.firstName') + ' ' + _.get(agent, 'user.lastName')
    }
    return name;
  }

}

angular
  .module('bringoz.admin.agents')
  .service('agentsAlerts', AgentsAlerts);
